import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const ChapterLabel = ({ chapter, label, dark = false }) => (
  <p
    className={`text-xs uppercase tracking-[0.25em] font-semibold ${
      dark ? "text-[#7C8C7E]" : "text-[#4A6572]"
    }`}
    data-testid={`chapter-label-${label.toLowerCase().replace(/\s/g, "-")}`}
  >
    {chapter} · {label}
  </p>
);
